// React
import React from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Label,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
} from 'reactstrap';

// Yup & Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';

export const ModalHasSchedule = ({
  isOpen,
  toggle,
  handleSubmitHasSchedule,
}) => {
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      scheduleType: '',
    },

    validationSchema: Yup.object().shape({
      scheduleType: Yup.string().required(),
    }),

    onSubmit: (values) => {
      handleSubmitHasSchedule(values.scheduleType);
      validation.resetForm();
      toggle();
    },
  });

  return (
    <React.Fragment>
      <Modal
        isOpen={isOpen}
        toggle={() => toggle()}
        centered
        zIndex={10000}
        size={'lg'}
        id="staticBackdrop"
      >
        <ModalHeader toggle={() => toggle()}>Editar lançamento</ModalHeader>
        <ModalBody>
          <Form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
            }}
          >
            <Row>
              <Col md={12}>
                <div className="mb-3">
                  <Label htmlFor="scheduleType" className="form-label">
                    Este lançamento faz parte de uma sequência. Como deseja
                    aplicar as alterações?
                  </Label>
                  <div className="d-block justify-content-between align-items-center mt-3">
                    <Col>
                      <Input
                        id="scheduleTypeOnly"
                        name="scheduleType"
                        className="me-2"
                        type="radio"
                        value={'only'}
                        onBlur={validation.handleBlur}
                        checked={validation.values.scheduleType === 'only'}
                        onChange={(e) => {
                          if (e.target.value === 'only') {
                            validation.handleChange({
                              target: {
                                name: 'scheduleType',
                                value: 'only',
                              },
                            });
                          }
                        }}
                        invalid={
                          !!(
                            validation.touched.scheduleType &&
                            validation.errors.scheduleType
                          )
                        }
                      />
                      <Label
                        htmlFor="scheduleTypeOnly"
                        className="text-uppercase"
                      >
                        Apenas neste
                      </Label>
                    </Col>

                    <Col>
                      <Input
                        id="scheduleTypeAll"
                        name="scheduleType"
                        className="me-2"
                        type="radio"
                        value={'all'}
                        onBlur={validation.handleBlur}
                        checked={validation.values.scheduleType === 'all'}
                        onChange={(e) => {
                          if (e.target.value === 'all') {
                            validation.handleChange({
                              target: {
                                name: 'scheduleType',
                                value: 'all',
                              },
                            });
                          }
                        }}
                        invalid={
                          !!(
                            validation.touched.scheduleType &&
                            validation.errors.scheduleType
                          )
                        }
                      />
                      <Label
                        htmlFor="scheduleTypeAll"
                        className="text-uppercase"
                      >
                        Neste e em todos na sequência
                      </Label>
                    </Col>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="d-flex align-items-center justify-content-end">
              <Button color="secondary" type="submit">
                Salvar alterações
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
